var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{staticClass:"flag",attrs:{"src":'./img/flags/' + _vm.img,"alt":_vm.$t('header.alts.lang')},on:{"click":_vm.translate}})}
var staticRenderFns = []

export { render, staticRenderFns }